import {
  IFormOfferings,
  IFormOfferingsLink,
} from 'legacy/lut/classes/models/partner360/IFormOfferings'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import {
  IProgramType,
  IProgramTypeLink,
} from 'legacy/lut/features/partner360/configuration/models/programType'

import Logger from 'core/utils/Logger'

export const mapProgramTypesLinks = (data: string) => {
  try {
    const parsedLinks = JSON.parse(data) as IFormOfferingsLink[]

    return parsedLinks.map<IProgramTypeLink>((link) => ({
      nameKey: link.NameKey,
      icon: link.Icon,
      url: link.URL,
    }))
  } catch (e) {
    Logger.error('Unable to parse program types links: ', e)
    return []
  }
}

export const mapPartner360ProgramTypes = (
  data: IFormOfferings[],
  partnerOfferings: string[]
): IProgramType[] => {
  return data.map((item) => ({
    programType: item.Offering as ProgramTypes,
    enabled: partnerOfferings.some((offering) => offering === item.Offering),
    isDeprecated: item.IsDeprecated === 1,
    translationKey: item.TranslationKey,
    translation: decodeURI(item.Translation),
    orderBy: item.OrderBy,
    links: item.Links.map<IProgramTypeLink>((link) => ({
      nameKey: link.NameKey,
      icon: link.Icon,
      url: link.URL,
    })),
  }))
}
